var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.465,
    height: 50.592,
    viewBox: "0 0 44.465 50.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-561.267 -131.95)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(561.267 131.95)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.237,0,31,6.394V17.542a35.635,35.635,0,0,0,21.649,32.8l.584.25.584-.25a35.635,35.635,0,0,0,21.649-32.8V6.394ZM72.5,17.542a32.717,32.717,0,0,1-19.268,29.85,32.717,32.717,0,0,1-19.268-29.85V8.626L53.237,3.085,72.5,8.626Z",
    transform: "translate(-31.004)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M583.42,135.452v46.8s-14.166-6.1-17.477-15.515-4.156-15.886-2.979-25.387C567.136,139.942,583.42,135.452,583.42,135.452Z",
    transform: "translate(0.08 -1.558)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.2c47e26047cdaac9ce463ab748628f37.svg";
export { ForwardRef as ReactComponent };